import React from 'react';
import styled from 'styled-components';
import Pill from '@99designs/frontend-components/components/Pill/Pill';
import Text from '../../../../shared/components/Text';
import { TableCell } from '../../../../shared/components/Table';
import { Bundle } from './bundles';
import { colors } from '../../../../shared/lib/styles';
import { space6 } from '../../../../shared/settings/spaces';
import Currency from '../../I18n/Currency';
import { between } from '../../../../shared/spa/core-components/utils/media';

const StyledTableCell = styled(TableCell)`
    background: ${colors.grey100};
    border-top-left-radius: ${space6}px;
    border-top-right-radius: ${space6}px;

    ${between('small', 'medium')} {
        padding-bottom: 4rem;
    }
`;

const TextWithMarginBottom = styled(Text)`
    margin-bottom: 0.4rem;
`;

interface Props {
    bundle: Bundle;
}
export function BundleTableHeader({ bundle }: Props) {
    return (
        <StyledTableCell as="th" scope="col">
            <TextWithMarginBottom baseClass={'heading'} variations={['h5']}>
                {bundle.title}
            </TextWithMarginBottom>
            <TextWithMarginBottom baseClass={'paragraph'} variations={['soft']}>
                {`${__('From')} `}
                <Currency
                    value={bundle.price.amountInCents}
                    currency={bundle.price.currency}
                    hideDecimal
                />
            </TextWithMarginBottom>
            <Pill variations={['callout']}>
                {`${__('Save up to')} `}
                <Currency
                    value={bundle.discount.amountInCents}
                    currency={bundle.discount.currency}
                    hideDecimal
                />
            </Pill>
        </StyledTableCell>
    );
}
